import { Form, Button } from 'antd';
import { colors } from '../../../shared/styles/baseStyle';
import { button, buttonItem } from './styles';

export default function PasswordSubmitButton({
  form,
  passwordName = 'password',
  children
}) {
  return (
    <Form.Item shouldUpdate style={buttonItem}>
      {() => {
        const password = form.getFieldValue(passwordName) || '';
        const confirmPassword = form.getFieldValue('confirmPassword') || '';
        const hasErrors = form
          .getFieldsError()
          .some(({ errors }) => errors.length);
        const isDisabled = password.length < 5 || !confirmPassword || hasErrors;
        return (
          <Button
            htmlType="submit"
            block
            size="large"
            disabled={isDisabled}
            style={{
              ...button,
              background: isDisabled ? colors.disabledGrey : colors.anytimeBlue
            }}
          >
            {children}
          </Button>
        );
      }}
    </Form.Item>
  );
}
